import React from "react";
//#region types
import { RecurringInvoiceBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { DateConstants, IconDefinitionConstants } from "utils/constants";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { StyleEnums } from "models/enums";
//#endregion
//#region components
import { Banner, StyledButton } from "components/common";
import { Grid } from "@mui/material";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const RecurringInvoiceBanner: React.FC<RecurringInvoiceBannerProps> = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const { invoice, loadInvoice } = props;
  const [loading, setLoading] = React.useState(false);

  const startInvoice = () => {
    setLoading(true);
    return recurringInvoiceService
      .start(invoice.id)
      .then((res) => {
        loadInvoice();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const stopInvoice = () => {
    setLoading(true);
    return recurringInvoiceService
      .stop(invoice.id)
      .then((res) => {
        loadInvoice();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const displayType =
    invoice.status === WintSuperkollAPIModel.RecurringInvoiceState.Ongoing
      ? StyleEnums.DisplayType.Info
      : StyleEnums.DisplayType.None;

  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RecurringInvoice)}
      icon={IconDefinitionConstants.WBolt}
      type={displayType}
    >
      <Grid container direction="column" spacing={3}>
        {invoice.status === WintSuperkollAPIModel.RecurringInvoiceState.Ongoing ? (
          <>
            <Grid item>
              {LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Invoice.RecurringInvoiceActiveBannerText,
                undefined,
                {
                  frequency: recurringInvoiceService.getFrequencyText(invoice.invoiceFrequency).toLocaleLowerCase(),
                  numOfRemainingInvoices:
                    invoice?.stopDate !== undefined ? `${invoice?.numberOfPlannedInvoices}` : "undefined",
                }
              )}
            </Grid>
            <Grid item>
              <StyledButton size="sm" displayType={displayType} onClick={stopInvoice} isSubmitting={loading}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Stop)}
              </StyledButton>
            </Grid>
          </>
        ) : invoice.status === WintSuperkollAPIModel.RecurringInvoiceState.Created ? (
          <>
            <Grid item>
              {LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Invoice.RecurringInvoiceNotStartedBannerText
              )}
            </Grid>
            <Grid item>
              <StyledButton size="sm" displayType={displayType} onClick={startInvoice} isSubmitting={loading}>
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Start)}
              </StyledButton>
            </Grid>
          </>
        ) : (
          <>
            <Grid item>
              {invoice.stopDate
                ? LocalizationHelperInstance.getFormattedMessage(
                    TranslationKeys.Invoice.RecurringInvoiceInactiveBannerText,
                    undefined,
                    {
                      stoppedDate: LocalizationHelperInstance.getFormattedDate(
                        invoice.stopDate,
                        DateConstants.DateMonthLongConfig
                      ),
                    }
                  )
                : ""}
            </Grid>
          </>
        )}
      </Grid>
    </Banner>
  );
};

export default RecurringInvoiceBanner;
